// extracted by mini-css-extract-plugin
export default {"errorPage":"error-page_errorPage__6cYMi","container":"error-page_container__JMveS","button":"error-page_button__68WOP"};